import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';

/**
 * Dialog read-only para visualizar todos los datos de una garantia D2D,
 * incluyendo ambos comentarios (creacion y atencion) y los snapshots de
 * auditoria (quien creo, tomo, anulo, con fechas).
 *
 * Si la garantia tiene `falla` registrada, busca en backend la cita
 * asociada (numero_orden = falla, ultimos 10 dias) y la muestra en una
 * seccion adicional. Lookup on-demand: solo se hace al abrir el dialog.
 */
@Component({
  selector: 'app-ver-garantia-dialog',
  templateUrl: './ver-garantia-dialog.component.html',
  styleUrls: ['./ver-garantia-dialog.component.scss']
})
export class VerGarantiaDialogComponent implements OnInit {

  garantia: any;
  cita: any = null;
  cargandoCita = false;

  constructor(
    private dialogRef: MatDialogRef<VerGarantiaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService,
  ) {
    this.garantia = data && data.garantia ? data.garantia : {};
  }

  ngOnInit(): void {
    // Solo buscar cita si la garantia tiene falla cargada (al atender).
    if (this.garantia && this.garantia.falla) {
      this.cargandoCita = true;
      this.gateway.get('garantiaD2dGetCitaPorFalla', { falla: this.garantia.falla })
        .then((res: any) => {
          this.cargandoCita = false;
          this.cita = res && res.cita ? res.cita : null;
        })
        .catch(() => {
          this.cargandoCita = false;
          this.cita = null;
        });
    }
  }

  estadoClass(estado: number): string {
    switch (Number(estado)) {
      case 0: return 'estado-pendiente';
      case 1: return 'estado-tomada';
      case 2: return 'estado-atendida';
      case 3: return 'estado-anulada';
      default: return '';
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
